import React from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../AuthConfig";
import { brandStrings } from '../../content/common';
import { landingStrings } from '../../content/landing';
import { trackClientError } from '../../services/telemetry';
import BrandMark from '../../components/common/BrandMark';

/**
 * Renders the landing icon experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.type - type value.
 * @returns {JSX.Element} The rendered interface.
 */
const LandingIcon = ({ type }) => <span className={`benefit-icon-art ${type}-art`} aria-hidden="true" />;

/**
 * Renders the landing view experience.
 *
 * @returns {JSX.Element} The rendered interface.
 */
export default function LandingView() {
    const { instance } = useMsal();

    /**
     * Handles auth.
     *
     * @param {*} e - e value.
     * @returns {void} No value; the operation applies its documented side effects.
     */
    const handleAuth = (e) => {
        e.preventDefault();
        // loginRedirect initiates the hosted UI for both Sign In and Sign Up
        instance.loginRedirect({
            ...loginRequest,
            redirectStartPage: window.location.href,
        }).catch(err => {
            trackClientError('auth.signin.failed', err, { source: 'landing' });
        });
    };

    return (
        <div className="landing-page">
            <div className="hero-card">
                <div className="landing-brand-lockup">
                    <BrandMark size="medium" />
                    <div>
                        <h1 className="brand-logo">
                            {brandStrings.nameStart}<span>{brandStrings.nameEnd}</span>
                        </h1>
                        <p className="brand-kicker">{brandStrings.kicker}</p>
                    </div>
                </div>
                <p className="tagline">{landingStrings.tagline}</p>
                <div className="landing-feature-list" aria-label={landingStrings.highlightsLabel}>
                    <div className="landing-feature">
                        <span className="landing-feature-icon feature-track"><LandingIcon type="track" /></span>
                        <div>
                            <strong>{landingStrings.highlights.track.title}</strong>
                            <span>{landingStrings.highlights.track.detail}</span>
                        </div>
                    </div>
                    <div className="landing-feature">
                        <span className="landing-feature-icon feature-recommendations"><LandingIcon type="recommendations" /></span>
                        <div>
                            <strong>{landingStrings.highlights.recommendations.title}</strong>
                            <span>{landingStrings.highlights.recommendations.detail}</span>
                        </div>
                    </div>
                    <div className="landing-feature">
                        <span className="landing-feature-icon feature-insights"><LandingIcon type="insights" /></span>
                        <div>
                            <strong>{landingStrings.highlights.insights.title}</strong>
                            <span>{landingStrings.highlights.insights.detail}</span>
                        </div>
                    </div>
                </div>
                <div className="auth-buttons">
                    <button onClick={handleAuth} className="btn-primary">
                        {landingStrings.auth.signInOrCreate}
                    </button>
                </div>
                <p className="landing-access-note">{landingStrings.auth.privateBeta}</p>
            </div>
        </div>
    );
}
